"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateCompareTriple = exports.DateZFromDateParts = exports.DatemorphISOString = void 0;
const DefaultOpts = {
    strict: true,
};
function DatemorphISOString(d, opts = DefaultOpts) {
    const strict = opts.strict;
    const candidates = [];
    const knownStr = d['date-time'];
    if (knownStr) {
        const date = new Date(knownStr);
        if (strict && !date) {
            throw new Error('Unable to parse: malformed date-time and strict enabled');
        }
        candidates.push(date);
    }
    const knownVal = d['timestamp'];
    if (knownVal) {
        const date = new Date(knownVal);
        if (strict) {
            if (!date) {
                throw new Error('Unable to parse: malformed timestamp and strict enabled');
            }
            if (candidates[0] && date.valueOf() != candidates[0].valueOf()) {
                throw new Error('Unable to parse: timestamp does not match date-time and strict enabled');
            }
        }
        candidates.push(date);
    }
    const date = DateZFromDateParts({ 'date-parts': d['date-parts'] }, opts);
    for (const c in candidates) {
        if (strict && !DateCompareTriple(candidates[c], date)) {
            throw new Error('Unable to parse: date-parts does not match and strict enabled');
        }
    }
    candidates.push(date);
    if (knownStr) {
        return knownStr;
    }
    return candidates[0].toISOString();
}
exports.DatemorphISOString = DatemorphISOString;
function DateZFromDateParts(d, opts = DefaultOpts) {
    const p = d['date-parts'];
    if (p.length == 0) {
        throw new Error('Malformed DateParts: No parts found in DateParts');
    }
    if (p.length > 1 && opts.strict) {
        throw new Error('Malformed DateParts: Multiple DateParts possibilities found');
    }
    const best = p[0];
    switch (best.length) {
        case 1:
            return new Date(Date.UTC(best[0], 0, 1));
        case 2:
            return new Date(Date.UTC(best[0], best[1] - 1, 1));
        case 3:
            return new Date(Date.UTC(best[0], best[1] - 1, best[2]));
        default:
            throw new Error('Malformed DateParts: Must have 1, 2, or 3 parts');
    }
}
exports.DateZFromDateParts = DateZFromDateParts;
function DateCompareTriple(d1, d2) {
    return (d1.getUTCFullYear() == d2.getUTCFullYear() &&
        d1.getUTCMonth() == d2.getUTCMonth() &&
        d1.getUTCDate() == d2.getUTCDate());
}
exports.DateCompareTriple = DateCompareTriple;
//# sourceMappingURL=utils.js.map